<template>
  <div class="st-builder">
    <div class="st-builder__color"></div>
    <div class="st-builder__header">
      <input class="st-builder__name"
        v-model="actState.name"
        placeholder="new state name"
        @blur="onNameBlur()"/>
        <fai icon="times" v-if="!noDelete"
          class="st-builder__del-icon"
          @click="$emit('delete')"/>
    </div>
    <div class="st-builder__content">
      <div class="st-builder__elem-cont"
        v-for="(item, index) in actState.rule.root"
        :key="index">
        <dynamic-text
          class="st-builder__elem"
          v-model="item.key"
          :minWidth="60"
          placeholder="var exist"
          @changed="onKeyChange($event, item)"/>
          <fai icon="times"
            class="st-builder__elem-icon-del"
            @click="onKeyDel(index)"/>
      </div>
      <div class="st-builder__elem-cont st-builder__elem-cont--new">
        <dynamic-text
          class="st-builder__elem"
          :minWidth="60"
          :value="newElem"
          @changed="onNewKeyEdit($event)"
          placeholder="var exist"/>
      </div>
    </div>
  </div>
</template>

<script>
import dynText from './DynamicTextarea.vue'
export default {
  data () {
    return {
      actState: {
        name: '',
        rule: {
          root: []
        }
      },
      newElem: ''
    }
  },

  props: {
    value: Object,
    noDelete: Boolean
  },

  watch: {
    value: function () {
      if(this.value) this.actState = this.value
    }
  },

  mounted () {
    if(this.value) this.actState = this.value
  },

  methods: {
    onNameBlur () {
      if(this.actState.id !== undefined) this.actState.edit = true
      this.$emit('nameBlur', this.actState)
    },

    onKeyChange (value, item) {
      console.log(value)
      if(value === '') return
      item.key = value
      if(this.actState.id !== undefined) this.actState.edit = true
    },

    onNewKeyEdit (key) {
      if(key === '') return
      this.newElem = key
      setTimeout(() => {
        this.actState.rule.root.push({
          key
        })
        if(this.actState.id !== undefined) this.actState.edit = true
        this.newElem = ''
      }, 0);
    },

    onKeyDel (index) {
      this.actState.rule.root.splice(index, 1)
      if(this.actState.id !== undefined) this.actState.edit = true
    }
  },

  components: {
    'dynamic-text': dynText
  }
}
</script>

<style lang="scss">
.st-builder {
  display: grid;
  grid-template-columns: 2px 1fr;
  grid-template-rows: max-content min-content;
  grid-column-gap: 12px;

  &__color {
    grid-column: 1/2;
    grid-row: 1/3;
    background: $primary;
    opacity: 0.2;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: solid 1px #e6e6e6;
    padding-bottom: 4px;
  }

  &__del-icon {
    color: $inactiveGrey;
    padding: 2px;
  }

  &__name {
    grid-column: 2/3;
    font-family: inherit;
    font-weight: 300;
    font-size: 0.95em;
    appearance: none;
    border: none;
    background: inherit;
    letter-spacing: 0.02em;

    &:focus {
      outline: 0;
      font-family: inherit;
    }
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 4px 2px;
    padding-top: 10px;
  }

  &__elem-cont {
    background: white;
    border: solid 1px $primary;
    border-radius: 2px;
    padding: 2px 0px;
    font-size: 0.9em;

    display: flex;
    align-items: center;

    &--new {
      border-color: $inactiveGrey;
    }
  }

  &__elem-icon-del {
    color: $inactiveGrey;
    margin-right: 6px;
    margin-top: 2px;
  }
}
</style>
